export default __webpack_public_path__ + "static/media/campaign_icon.126febb9.svg";